import { Component } from '@angular/core';

@Component({
  selector: 'initiative-partners',
  standalone: true,
  imports: [],
  templateUrl: './initiative-partners.component.html',
  styleUrl: './initiative-partners.component.scss'
})
export class InitiativePartnersComponent {

}
